import { ORDER_STATUS, FILE_ROOT, FILE_ACCESS_PRIVATE } from '@/common/constants/'
import { getWebToken } from '@/common/utils/common'
import dateFormat from '../utils/date'
import NP from 'number-precision'

function pluralize(time, label) {
  if (time === 1) {
    return time + label
  }
  return time + label + 's'
}
export function timeAgo(time) {
  const between = Date.now() / 1000 - Number(time)
  if (between < 3600) {
    return pluralize(~~(between / 60), ' minute')
  } else if (between < 86400) {
    return pluralize(~~(between / 3600), ' hour')
  } else {
    return pluralize(~~(between / 86400), ' day')
  }
}

export function parseTime(time, cFormat) {
  if (arguments.length === 0 || typeof time === 'undefined' || !time) {
    return null
  }
  if ((time + '').length === 10) {
    time = +time * 1000
  }

  const format = cFormat || '{y}-{M}-{d} {h}:{m}:{s}'
  let date
  if (typeof time == 'object') {
    date = time
  } else {
    date = new Date(parseInt(time))
  }
  const formatObj = {
    y: date.getFullYear(),
    M: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    m: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }

  const time_str = format.replace(/{(y|M|d|h|m|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1]
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

// 时间戳(毫秒级)格式化
export function formatTime(timestamp, option) {
  if (timestamp === void 0) {
    return '--'
  }

  const d = new Date(timestamp)

  if (option) {
    return parseTime(timestamp, option)
  } else {
    return (
      d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分'
    )
  }
}

/**
 * 分变成元
 * @num 金额（分）
 */
export function formatMoneyCent(money) {
  if (typeof money === 'string') {
    money = parseFloat(money)
    if (isNaN(money)) {
      return '--'
    }
  } else if (typeof money !== 'number') {
    return '--'
  }
  return parseFloat(NP.divide(money, 100).toFixed(2))
}

/**
 * ton变成吨
 */
export function formatWeight(weight) {
  if (typeof weight === 'string') {
    weight = parseFloat(weight)
    if (isNaN(weight)) {
      return '--'
    }
  } else if (typeof weight !== 'number') {
    return '--'
  }
  return parseFloat(NP.divide(weight, 10000))
    .toFixed(7)
    .replace(/0+$/, '')
    .replace(/\.$/, '')
}

// 另一个同类的方法有问题
export function formatWeightWithUnitFix(weight, unit = 'TON', isHideUint = false) {
  if (typeof weight === 'string') {
    weight = parseFloat(weight)
    if (isNaN(weight)) {
      return '0'
    }
  } else if (typeof weight !== 'number') {
    return '0'
  }
  let weightValue = 0
  let unitValue = ''
  if (unit === 'KG') {
    weightValue = parseFloat(weight / 10)
    unitValue = '千克'
  } else {
    weightValue = parseFloat(weight / 10000)
    unitValue = '吨'
  }
  weightValue = weightValue
    .toFixed(7)
    .replace(/0+$/, '')
    .replace(/\.$/, '')
  return `${weightValue}${isHideUint ? '' : ` ${unitValue}`}`
}

/**
 * 带单位的重量格式化
 * @param weight 重量数据
 * @param unit 单位
 * @param isHideUint 是否隐藏单位
 * @returns {string}
 */
export function formatWeightWithUnit(weight, unit = 'TON', isHideUint = false) {
  if (typeof weight === 'string') {
    weight = parseFloat(weight)
    if (isNaN(weight)) {
      return '0'
    }
  } else if (typeof weight !== 'number') {
    return '0'
  }
  let weightValue = 0
  let unitValue = ''
  if (unit === 'KG') {
    weightValue = parseFloat(weight / 10)
    unitValue = '千克'
  } else if (unit === 'TON') {
    weightValue = parseFloat(weight / 10000)
    unitValue = '吨'
  } else {
    weightValue = weight
    unitValue = exUnit(unit)
  }
  weightValue = weightValue
    .toFixed(7)
    .replace(/0+$/, '')
    .replace(/\.$/, '')
  return `${weightValue}${isHideUint ? '' : ` ${unitValue}`}`
}

/**
 * 数字 格式化
 */
export function nFormatter(num, digits) {
  const si = [
    { value: 1e18, symbol: 'E' },
    { value: 1e15, symbol: 'P' },
    { value: 1e12, symbol: 'T' },
    { value: 1e9, symbol: 'G' },
    { value: 1e6, symbol: 'M' },
    { value: 1e3, symbol: 'k' }
  ]
  for (let i = 0; i < si.length; i++) {
    if (num >= si[i].value) {
      return (
        (num / si[i].value + 0.1).toFixed(digits).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') +
        si[i].symbol
      )
    }
  }
  return num.toString()
}

export function html2Text(val) {
  const div = document.createElement('div')
  div.innerHTML = val
  return div.textContent || div.innerText
}

export function toThousandslsFilter(num) {
  return (+num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
}

/**
 * 金额整数时显示整数, 小数时最多精确到小数后两位
 * @num 金额
 */

export function formatMoney(money) {
  if (typeof money === 'string') {
    money = parseFloat(money)
    if (isNaN(money)) {
      return '--'
    }
  } else if (typeof money !== 'number') {
    return '--'
  }
  return parseFloat(money.toFixed(2))
}

/**
 * 用千分号分隔
 */
export function formatPermil(num) {
  var money = formatMoney(num)
  var parts = money.toString().split('.')
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  return parts.join('.')
}

/**
 *距离格式化, 大于1km显示xxkm(保留一位小时), 小于1km显示xxm
 * @num 距离（米）
 */
export function formatDistance(num) {
  var value = parseFloat(num)

  if (isNaN(value)) return '--'

  if (value >= 1000) {
    return (value / 1000).toFixed(1) + 'km'
  }

  return Math.ceil(value) + 'm'
}

/**
 * 倒计时格式化(X天X时X分，X时X分，X分)
 * @timestamp 毫秒级时间戳
 */
export function formatCountdown(timestamp) {
  if (!timestamp || timestamp <= 0) return ''

  var days = parseInt(timestamp / (1000 * 60 * 60 * 24))
  var hours = parseInt((timestamp - days * 1000 * 60 * 60 * 24) / (1000 * 60 * 60))
  var mins = parseInt(
    (timestamp - days * 1000 * 60 * 60 * 24 - hours * 1000 * 60 * 60) / (1000 * 60)
  )

  return [
    days > 0 ? days + '天' : '',
    hours > 0 ? hours + '小时' : '',
    mins > 0 ? mins + '分' : ''
  ].join('')
}

/**
 * 将金额转换成汉字大写
 * @param n 金额
 * @returns {string}
 */
export function formatAmountCapitalized(n) {
  let fraction = ['角', '分']
  let digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖']
  let unit = [
    ['元', '万', '亿'],
    ['', '拾', '佰', '仟']
  ]
  let head = n < 0 ? '（负数）' : ''
  n = Math.abs(n)
  let s = ''
  for (let i = 0; i < fraction.length; i++) {
    s += (digit[Math.floor(shiftRight(n, 1 + i)) % 10] + fraction[i]).replace(/零./, '')
  }
  s = s || '整'
  n = Math.floor(n)
  for (let i = 0; i < unit[0].length && n > 0; i++) {
    let p = ''
    for (let j = 0; j < unit[1].length && n > 0; j++) {
      p = digit[n % 10] + unit[1][j] + p
      n = Math.floor(shiftLeft(n, 1))
    }
    s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s
  }
  return (
    head +
    s
      .replace(/(零.)*零元/, '元')
      .replace(/(零.)+/g, '零')
      .replace(/^整$/, '零元整')
  )
}
// 向右移位
function shiftRight(number, digit) {
  digit = parseInt(digit, 10)
  let value = number.toString().split('e')
  return +(value[0] + 'e' + (value[1] ? +value[1] + digit : digit))
}
// 向左移位
function shiftLeft(number, digit) {
  digit = parseInt(digit, 10)
  let value = number.toString().split('e')
  return +(value[0] + 'e' + (value[1] ? +value[1] - digit : -digit))
}

/** 订单状态格式化 */
export function orderStatusFormat(input) {
  let result = ''
  if (input) {
    result = ORDER_STATUS[input]
  }
  return result
}

/** 货币格式化 */
export function currencyFormat(input, noPrefix) {
  let result = 0
  if (input) {
    result = input / 100
    result = String(result.toFixed(2))
    let re = /(-?\d+)(\d{3})/
    while (re.test(result)) {
      result = result.replace(re, '$1,$2')
    }
  }
  return noPrefix ? result : `¥ ${result}`
}
/** 手机号格式化 */
export function phoneFormat(input) {
  let result = ''
  if (input) {
    result = input.replace('+86', '')
  }
  return result
}

/** 日期格式化 */
export function dataFormat(input, format) {
  let result = ''
  let _format = format || 'yyyy-MM-dd hh:mm:ss'
  if (input) {
    result = dateFormat(input, _format)
  }
  return result
}
/** 银行卡号格式化 */
export function bankNoformat(bankNo) {
  if (!bankNo) return ''
  return bankNo.toString().replace(/(\d{4})(?=\d)/g, '$1 ')
}

export function exUnit(unit) {
  switch (unit) {
    case 'ROOT':
      return '根'
    case 'SHEET':
      return '张'
    case 'AN':
      return '个'
    case 'KG':
    case 'TON':
    case 'PIECE':
    default:
      return '件'
  }
}

export function exUnitToBaseUnit(unit) {
  switch (unit) {
    case 'ROOT':
      return '根'
    case 'SHEET':
      return '张'
    case 'AN':
      return '个'
    case 'PIECE':
      return '件'
    case 'KG':
      return '千克'
    case 'TON':
    default:
      return '吨'
  }
}

export function exUnitToWeight(unit) {
  switch (unit) {
    case 'KG':
      return '千克'
    case 'TON':
    case 'ROOT':
    case 'SHEET':
    case 'AN':
    case 'PIECE':
    default:
      return '吨'
  }
}

/**
 * 格式化重量单位
 * @param unit 单位字符串
 * @returns {string}
 */
export function formatWeightUnit(unit) {
  switch (unit) {
    case 'ROOT':
      return '根'
    case 'SHEET':
      return '张'
    case 'AN':
      return '个'
    case 'KG':
      return '千克'
    case 'TON':
      return '吨'
    case 'PIECE':
    default:
      return '件'
  }
}

/**
 * 生成图片链接
 * @param key 文件 key
 * @param options
 * @param open 公开 私有
 */
export function makeImage(arg, { width = '', height = '' } = {}, open = true) {
  if (arg === '') return ''
  const havePrefix = arg.startsWith('http') && arg.includes('zhaogang.com')
  // 原始图片
  if (arg.startsWith('http') && !havePrefix) {
    return arg
  }
  let suffix = ''
  if (width !== '' && height !== '') {
    suffix = `?x-oss-process=image/resize,w_${width},h_${height},m_fill`
  }
  if (open) {
    return `${FILE_ROOT}${arg}${suffix}`
  } else {
    return `${FILE_ACCESS_PRIVATE}${arg}&_tk=${getWebToken()}`
  }
}

export function convertPayChannel(payChannel, defauteText = '--') {
  let text = defauteText
  if (payChannel === 'CHINAPAY') {
    text = 'ChinaPay'
  } else if (payChannel === 'CMB') {
    text = '招商银行'
  } else if (payChannel === 'OFFLINE') {
    text = '线下支付'
  } else if (payChannel === 'SELL_ON_CREDIT') {
    text = '赊销采购'
  } else if (payChannel === 'HUI_FU_PAY') {
    text = '汇付支付'
  }
  return text
}
// 获取计量方式
export function getValuationUnitWayChn(way) {
  if (way === 1) {
    return '理计'
  } else if (way === 2) {
    return '过磅'
  } else if (way === 3) {
    return '抄码'
  }
  return ''
}

export function fileUrlAdapter(fk) {
  if (!fk) {
    return ''
  }
  if (fk.startsWith('http') || fk.startsWith('//')) {
    return fk
  } else if (fk.startsWith('o')) {
    return FILE_ROOT + fk
  } else {
    return `${FILE_ACCESS_PRIVATE + fk}&_tk=${getWebToken()}`
  }
}

// 获取配送方式
export function getLogisticsWayChn(way) {
  if (way === 1) {
    return '自提'
  } else if (way === 2) {
    return '商家配送'
  } else if (way === 3) {
    return '过户'
  }
  return ''
}

// 文件大小转换
export function fileSize(size) {
  const unit = size / 1024
  if (unit < 1) {
    return `${(size / 1024).toFixed()}B`
  } else {
    if (unit < 1024) {
      return `${unit.toFixed()}KB`
    } else if (unit > 1024 && unit < 1024 * 1024) {
      return `${(unit / 1024).toFixed(2)}M`
    } else {
      return `${(unit / (1024 * 1024)).toFixed()}G`
    }
  }
}
